(function () {
  'use strict';

  var SKIP_ATTR = 'pongoSkipSubscribePopup';
  var STAY_AI_APP_ID = '5859381';

  function decodeHtml(text) {
    return String(text || '').replace(/&amp;/g, '&');
  }

  function parseJsonScript(el) {
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (err) {
      return null;
    }
  }

  function closestProductRoot(node) {
    if (!node || !node.closest) return null;
    return (
      node.closest('.product-tile') ||
      node.closest('[data-product-root]') ||
      node.closest('.product-content') ||
      node.closest('.main-product-info') ||
      null
    );
  }

  function isCartAddForm(form) {
    if (!(form instanceof HTMLFormElement)) return false;
    var action = String(form.getAttribute('action') || form.action || '').toLowerCase();
    return form.hasAttribute('data-product-form') || action.indexOf('/cart/add') !== -1;
  }

  function labelLooksOnetime(text) {
    var t = String(text || '').toLowerCase();
    return t.indexOf('one-time') !== -1 || t.indexOf('one time') !== -1 || t.indexOf('onetime') !== -1;
  }

  function labelLooksSubscribe(text) {
    var t = String(text || '').toLowerCase();
    return t.indexOf('subscribe') !== -1 || t.indexOf('subscription') !== -1;
  }

  function sellingPlanValue(form) {
    var field = form && form.querySelector('input[name="selling_plan"], select[name="selling_plan"]');
    return field ? String(field.value || '').trim() : '';
  }

  function isOneTimePurchase(form) {
    if (sellingPlanValue(form)) return false;
    var root = closestProductRoot(form);
    if (!root) return true;
    var wrappers = root.querySelectorAll('.stayai-purchase-label__wrapper');
    var i;
    for (i = 0; i < wrappers.length; i++) {
      var radio =
        wrappers[i].querySelector('input[type="radio"]:checked') ||
        wrappers[i].querySelector('input[type="radio"][aria-checked="true"]');
      if (!radio) continue;
      var text = wrappers[i].textContent || '';
      if (labelLooksOnetime(text)) return true;
      if (labelLooksSubscribe(text)) return false;
    }
    var checked = root.querySelector('[name="purchase_option"]:checked');
    if (checked) {
      if (checked.closest('.one-time')) return true;
      if (checked.closest('.subscription')) return false;
      var val = String(checked.value || '').trim();
      return val === '' || val === 'onetime';
    }
    var stayBox = root.querySelector('.stayai-subscription-box');
    if (stayBox) {
      var style = window.getComputedStyle(stayBox);
      if (style.display === 'none' || style.visibility === 'hidden') return true;
    }
    return true;
  }

  function activeCardQty(root) {
    var active = root && root.querySelector && root.querySelector('.pdp-qty-opt.is-active');
    if (!active) return 1;
    return parseInt(active.getAttribute('data-qty'), 10) || 1;
  }

  function targetDiscountForQty(qty) {
    if (qty >= 3) return 50;
    if (qty === 2) return 40;
    return 30;
  }

  function intervalDaysFromText(text) {
    var t = String(text || '')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();
    if (!t) return 0;
    var every = t.match(/every\s+(\d+)\s*(days?|months?|weeks?)/);
    if (every) {
      var n = parseInt(every[1], 10) || 0;
      if (/month/.test(every[2])) return n * 30;
      if (/week/.test(every[2])) return n * 7;
      return n;
    }
    if (/90/.test(t) || /3\s*months?/.test(t)) return 90;
    if (/60/.test(t) || /2\s*months?/.test(t)) return 60;
    if (/30/.test(t) || /monthly/.test(t) || /1\s*months?/.test(t) || /^month/.test(t)) return 30;
    return 0;
  }

  function planDays(plan) {
    return intervalDaysFromText(plan.optionValue) || intervalDaysFromText(plan.name) || 0;
  }

  function planLabel(plan) {
    var label = String(plan.optionValue || plan.name || '').trim();
    if (!label) return 'Subscribe';
    if (/^every\s+/i.test(label) || /deliver/i.test(label)) return label;
    var days = planDays(plan);
    if (days) return 'Every ' + days + ' days';
    return label;
  }

  function formatPrice(cents) {
    var amount = Number(cents) || 0;
    if (typeof formatMoney === 'function') {
      return formatMoney(amount, (window.theme && theme.moneyFormat) || undefined);
    }
    return '$' + (amount / 100).toFixed(2);
  }

  function findPopupForForm(form) {
    var root = closestProductRoot(form);
    if (!root) return null;
    var local = root.querySelector('.subscribe-save-popup');
    if (local) return local;
    var popups = document.querySelectorAll('.subscribe-save-popup');
    var i;
    for (i = 0; i < popups.length; i++) {
      if (popups[i]._pongoHome && root.contains(popups[i]._pongoHome)) {
        return popups[i];
      }
    }
    return null;
  }

  function getProductData(popup) {
    return parseJsonScript(popup.querySelector('[data-subscribe-save-product]'));
  }

  function stayAiPlans(plans) {
    var list = Array.isArray(plans) ? plans : [];
    var stay = list.filter(function (p) {
      return String(p.appId) === STAY_AI_APP_ID;
    });
    return stay.length ? stay : list;
  }

  function plansForQty(allPlans, qty) {
    var target = targetDiscountForQty(qty);
    var matched = allPlans.filter(function (p) {
      return Number(p.discount) === target;
    });
    return matched.length ? matched : allPlans;
  }

  function defaultPlanId(plans) {
    var thirty = plans.find(function (p) {
      return planDays(p) === 30;
    });
    return String((thirty || plans[0] || {}).id || '');
  }

  function selectSubscribeOption(root) {
    var wrappers = root.querySelectorAll('.stayai-purchase-label__wrapper');
    var i;
    var radio = null;
    for (i = 0; i < wrappers.length; i++) {
      if (labelLooksOnetime(wrappers[i].textContent)) continue;
      if (!labelLooksSubscribe(wrappers[i].textContent)) continue;
      radio = wrappers[i].querySelector('input[type="radio"]');
      if (radio) break;
    }
    if (!radio) {
      radio =
        root.querySelector('#purchaseTypeSubscription') ||
        root.querySelector('.subscription input[type="radio"]') ||
        root.querySelector('.subscription [name="purchase_option"]');
    }
    if (!radio) return;
    if (radio.checked) return;
    try {
      radio.click();
    } catch (err) {
      radio.checked = true;
      radio.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  function setFormSellingPlan(form, planId) {
    var input = form.querySelector('input[name="selling_plan"]');
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'selling_plan';
      form.appendChild(input);
    }
    input.value = planId ? String(planId) : '';
    var stay = form.querySelector('input[name="stayai_selling_plan"]');
    if (stay) stay.value = input.value;
    var root = closestProductRoot(form);
    var dropdown = root
      ? root.querySelector('select.stayai-subscription-dropdown') ||
        root.querySelector('select[name="selling_plan"]')
      : null;
    if (dropdown && planId) {
      var opt = Array.prototype.find.call(dropdown.options, function (o) {
        return String(o.value) === String(planId);
      });
      if (opt) dropdown.value = String(planId);
    }
  }

  function continueSubmit(form) {
    form.dataset[SKIP_ATTR] = '1';
    if (typeof form.requestSubmit === 'function') {
      form.requestSubmit();
    } else {
      form.submit();
    }
    window.setTimeout(function () {
      delete form.dataset[SKIP_ATTR];
    }, 0);
  }

  function bindPopup(popup) {
    if (!popup || popup._pongoShowSubscribeSave) return;
    if (popup.parentNode && popup.parentNode !== document.body) {
      popup._pongoHome = popup.parentNode;
      document.body.appendChild(popup);
    }
    var overlay = popup.querySelector('.subscribe-save-popup__overlay');
    var closeBtn = popup.querySelector('.subscribe-save-popup__close');
    var titleEl = popup.querySelector('.subscribe-save-popup__title');
    var imageEl = popup.querySelector('.subscribe-save-popup__image');
    var productTitleEl = popup.querySelector('.subscribe-save-popup__product-title');
    var variantEl = popup.querySelector('.subscribe-save-popup__variant');
    var salePriceEl = popup.querySelector('.subscribe-save-popup__price-sale');
    var comparePriceEl = popup.querySelector('.subscribe-save-popup__price-compare');
    var selectEl = popup.querySelector('.subscribe-save-popup__select');
    var subscribeBtn = popup.querySelector('.subscribe-save-popup__subscribe');
    var declineBtn = popup.querySelector('.subscribe-save-popup__decline');
    var dialogEl = popup.querySelector('.subscribe-save-popup__dialog');
    var pendingForm = null;
    var currentPlans = [];
    var currentVariant = null;

    function lockPageScroll() {
      document.documentElement.classList.add('subscribe-save-popup-open');
      document.body.classList.add('subscribe-save-popup-open');
    }

    function unlockPageScroll() {
      document.documentElement.classList.remove('subscribe-save-popup-open');
      document.body.classList.remove('subscribe-save-popup-open');
    }

    function hidePopup() {
      popup.hidden = true;
      popup.classList.remove('is-open');
      popup.setAttribute('aria-hidden', 'true');
      unlockPageScroll();
      pendingForm = null;
    }

    function updatePrices(planId) {
      if (!currentVariant) return;
      var plan = currentPlans.find(function (p) {
        return String(p.id) === String(planId);
      });
      var allocation = plan && currentVariant.allocations ? currentVariant.allocations[String(plan.id)] : null;
      var sale = allocation ? allocation.price : currentVariant.price;
      var compare = allocation && allocation.compareAt ? allocation.compareAt : currentVariant.price;
      salePriceEl.textContent = formatPrice(sale);
      if (compare > sale) {
        comparePriceEl.textContent = formatPrice(compare);
        comparePriceEl.hidden = false;
      } else {
        comparePriceEl.textContent = '';
        comparePriceEl.hidden = true;
      }
    }

    function populateSelect(plans, selectedId) {
      selectEl.innerHTML = plans
        .map(function (plan) {
          var selected = String(plan.id) === String(selectedId) ? ' selected' : '';
          return '<option value="' + plan.id + '"' + selected + '>' + planLabel(plan) + '</option>';
        })
        .join('');
      selectEl.value = String(selectedId);
    }

    function showPopup(form) {
      var productData = getProductData(popup);
      if (!productData || productData.requiresSellingPlan) {
        continueSubmit(form);
        return false;
      }

      var variantId = form.querySelector('[name="id"]') && form.querySelector('[name="id"]').value;
      var variant = (productData.variants || []).find(function (v) {
        return String(v.id) === String(variantId);
      });
      if (!variant) {
        continueSubmit(form);
        return false;
      }

      var root = closestProductRoot(form);
      var qty = activeCardQty(root);
      var plans = plansForQty(stayAiPlans(productData.plans || []), qty).filter(function (plan) {
        return variant.allocations && variant.allocations[String(plan.id)];
      });
      if (!plans.length) {
        continueSubmit(form);
        return false;
      }

      pendingForm = form;
      currentPlans = plans;
      currentVariant = variant;

      var defaultId = defaultPlanId(plans);
      var discount = Number(plans[0].discount) || targetDiscountForQty(qty);
      var titleTemplate = decodeHtml(productData.titleTemplate || '');
      titleEl.textContent = discount
        ? titleTemplate.replace('__PERCENT__', String(discount))
        : decodeHtml(productData.titleGeneric || '') ||
          titleTemplate.replace(' {{ percent }}%', '').replace('__PERCENT__%', '').replace('__PERCENT__', '');

      productTitleEl.textContent = productData.title || popup.dataset.productTitle || '';
      variantEl.textContent = variant.title === 'Default Title' ? '' : variant.title || '';

      var imageSrc = variant.featuredImage || productData.featuredImage || '';
      if (imageSrc) {
        imageEl.src = imageSrc;
        imageEl.alt = productData.title || '';
        imageEl.hidden = false;
      } else {
        imageEl.hidden = true;
      }

      populateSelect(plans, defaultId);
      updatePrices(defaultId);
      lockPageScroll();
      popup.hidden = false;
      popup.classList.add('is-open');
      popup.setAttribute('aria-hidden', 'false');
      if (dialogEl) dialogEl.scrollTop = 0;
      if (closeBtn) closeBtn.focus();
      return true;
    }

    function submitWithPlan() {
      if (!pendingForm) return;
      var form = pendingForm;
      var planId = selectEl.value;
      var root = closestProductRoot(form);
      hidePopup();
      selectSubscribeOption(root);
      setFormSellingPlan(form, planId);
      window.setTimeout(function () {
        setFormSellingPlan(form, planId);
        continueSubmit(form);
      }, 80);
    }

    function submitOneTime() {
      if (!pendingForm) return;
      var form = pendingForm;
      hidePopup();
      setFormSellingPlan(form, '');
      continueSubmit(form);
    }

    if (subscribeBtn) subscribeBtn.addEventListener('click', submitWithPlan);
    if (declineBtn) declineBtn.addEventListener('click', submitOneTime);
    if (closeBtn) closeBtn.addEventListener('click', submitOneTime);
    if (overlay) overlay.addEventListener('click', submitOneTime);
    if (selectEl) {
      selectEl.addEventListener('change', function () {
        updatePrices(selectEl.value);
      });
    }

    popup.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') submitOneTime();
    });

    popup.addEventListener(
      'wheel',
      function (e) {
        if (dialogEl && !dialogEl.contains(e.target)) e.preventDefault();
      },
      { passive: false }
    );

    popup.addEventListener(
      'touchmove',
      function (e) {
        if (dialogEl && !dialogEl.contains(e.target)) e.preventDefault();
      },
      { passive: false }
    );

    popup._pongoShowSubscribeSave = showPopup;
  }

  function onSubmit(event) {
    var form = event.target;
    if (!isCartAddForm(form)) return;
    if (form.dataset[SKIP_ATTR] === '1') return;
    if (!isOneTimePurchase(form)) return;
    var popup = findPopupForForm(form);
    if (!popup || typeof popup._pongoShowSubscribeSave !== 'function') return;
    event.preventDefault();
    event.stopImmediatePropagation();
    popup._pongoShowSubscribeSave(form);
  }

  function init() {
    var popups = document.querySelectorAll('.subscribe-save-popup');
    popups.forEach(bindPopup);
    if (window.__pongoSubscribeSaveInit) return;
    if (!popups.length) return;
    window.__pongoSubscribeSaveInit = true;
    document.addEventListener('submit', onSubmit, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
